import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './ui/Button';
import { useAuth } from '../contexts/AuthContext';

const WHOP_PLANS = {
  pro_monthly: 'plan_DBXVLNLTqBIYK',
  pro_annual: 'plan_2nQAUoWggHLBk',
  elite_monthly: 'plan_eXbZqIxnR13uz',
  elite_annual: 'plan_auyU5uFXjcyIE'
};

const UpgradeButton = ({ 
  plan = 'pro', // 'pro' or 'elite'
  billingCycle = 'monthly', // 'monthly' or 'annual'
  variant = 'default',
  size = 'default',
  fullWidth = false,
  children,
  className = ''
}) => {
  const navigate = useNavigate();
  const { profile } = useAuth();

  const handleUpgrade = () => {
    const currentTier = profile?.subscription_tier;
    
    // If user already has this tier or higher, go to subscription page
    if (currentTier === plan || (currentTier === 'elite' && plan === 'pro')) {
      navigate('/app/subscription');
      return;
    }

    // Determine which plan to redirect to
    const planKey = billingCycle === 'annual'
      ? `${plan}_annual`
      : `${plan}_monthly`;
    
    const whopPlanId = WHOP_PLANS[planKey];
    
    // Redirect directly to Whop checkout
    // Webhook will create account and send magic link
    const checkoutUrl = `https://whop.com/checkout/${whopPlanId}?d2c=true`;
    window.location.href = checkoutUrl;
  };

  // Determine button text
  let buttonText = children;
  if (!buttonText) {
    const currentTier = profile?.subscription_tier;
    if (currentTier === plan) {
      buttonText = 'Current Plan';
    } else if (currentTier === 'elite' && plan === 'pro') {
      buttonText = 'Downgrade';
    } else if (!currentTier || currentTier === 'free') {
      buttonText = `Get ${plan === 'pro' ? 'Pro' : 'Elite'}`;
    } else {
      buttonText = `Upgrade to ${plan === 'pro' ? 'Pro' : 'Elite'}`;
    }
  }

  const isCurrentPlan = profile?.subscription_tier === plan;

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      onClick={handleUpgrade}
      disabled={isCurrentPlan}
      className={className}
      iconName={isCurrentPlan ? 'Check' : 'Zap'}
      iconPosition="left"
    >
      {buttonText}
    </Button>
  );
};

export default UpgradeButton;
